import { z } from 'zod';

import { CityKeySchema } from '../city-key/city-key';

/**
 * One city the venue directory holds, with how many venues are in it.
 *
 * This is what makes the city filter a **select over a known set** rather than a
 * free-text box — U0 forbids the lowest-common-denominator control where the
 * domain has a known set of values, and the set of cities is exactly that: it is
 * whatever the directory currently contains.
 *
 * The same read serves two surfaces: the admin list's filter, and (P25e) the
 * member browse's city facet.
 *
 * **`label` is never blank.** The api resolves it as `label ?? cityKey`, so a
 * city whose venues are untranslated in the caller's locale still renders a
 * readable option instead of an empty row nothing on screen explains.
 */
export const VenueCitySchema = z
  .object({
    cityKey: CityKeySchema,
    label: z.string().min(1),
    venueCount: z.number().int().nonnegative(),
  })
  .strict();

export type VenueCity = z.infer<typeof VenueCitySchema>;
